import { ConnectedComponent } from './Connected.component';
import { enhance } from './Connected.enhancers';

export const Connected = enhance(ConnectedComponent);
